// src/app/shared-data.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TherapistModel } from '../models/api/TherapistModel';


@Injectable({
  providedIn: 'root'
})
export class SharedTherapistDetailService {

  private therapistDataSource = new BehaviorSubject<TherapistModel>(new TherapistModel);

  therapistData$ = this.therapistDataSource.asObservable();

  setTherapistData(data: any): void {
    this.therapistDataSource.next(data);
  }

   private showClockIn = new Subject<void>();
  showClockIn$ = this.showClockIn.asObservable();

   triggerClockInPopup(): void {
    this.showClockIn.next();
  }

}